/**
 * DCMS FRONTEND API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { AppointmentStatusEnum } from './appointmentStatusEnum';
import { SessionTypeEnum } from './sessionTypeEnum';


import {ValidatorFn, Validators} from "@angular/forms";

export interface CalendarRequest { 
    therapistIds: Array<number>;
    organizationIds?: Array<number>;
    fromDate: string;
    toDate: string;
    sessionTypes?: Array<SessionTypeEnum>;
    appointmentStatuses?: Array<AppointmentStatusEnum>;
}
export const CalendarRequest_therapistIds_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const CalendarRequest_organizationIds_Validators: ValidatorFn[] =
    [ ];

export const CalendarRequest_fromDate_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const CalendarRequest_toDate_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const CalendarRequest_sessionTypes_Validators: ValidatorFn[] =
    [ ];

export const CalendarRequest_appointmentStatuses_Validators: ValidatorFn[] =
    [ ];


